<template>
  <transition name="pop">
    <div class="message-modal" role="dialog">
      <div class="content-message-modal">
        <button @click="$emit('update:modelValue', true);
            $emit('close')"
            class="button-x">&times;</button>
        <h2>{{title}}</h2>
        <p v-for="linha in text" :key="linha.index">{{linha}}</p>
        <div class="btn-modal-message">
          <button class="w3-closebtn"
            @click="$emit('update:modelValue', false);
            $emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'DialogModal',
  emits: [
    'update:modelValue',
    'close'
  ],
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: String,
    text: Array,
    image: Image
  },
  data () {
    return {
    }
  }

}
</script>

<style lang="scss">
  .message-modal {
    position: fixed;
    z-index: 999;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(53, 53, 53, 0.5);
    display: grid;
    overflow-y: initial !important;
    align-content: center;
    transition: opacity 0.15s ease;
    animation: .35s .8s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
  }

  .message-modal:target {
    opacity: 1;
    pointer-events: auto;
  }

  .content-message-modal {
    width: 70%;
    position: relative;
    background-color: #ffffff;
    align-content: center;
    left: 15%;
    animation: modalFadeIn 500ms forwards;

    .btn-modal-message {
      display: inline-block;
    }

    .btn-cancelar-dialog {
      background-color: #ffffff00;
      color: #C2171A;
    }

    button {
      width: auto;
    }

    .button-x {
      display: flex;
      float: right;
      position: relative;
      background-color: transparent;
      color: #000;
      font-size: 1.8rem;
    }
  }

  @keyframes modalFadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .pop-enter-active,
  .pop-leave-active {
    transition: transform 900ms opacity 900ms ease;
  }

  .pop-enter,
  .pop-leave-to {
    opacity: 0;
    transform: scale(0.3) translateY(-50%);
  }
</style>
